<template>
  <section>
    <div class="card mb-2">
      <div class="card-body px-1 py-2">
        <!-- Normal template-->
        <div class="row d-flex align-items-center" v-if="!isEditing">
          <div class="col-lg-1 col-md-2 text-center">
            <h6>/{{ messageTemplate.key }}</h6>
          </div>

          <div class="col-md-2 text-center">
            <span>{{ messageTemplate.category ? messageTemplate.category.name : '' }}</span>
          </div>

          <div class="col-md-2 text-center">
            <span>{{ messageTemplate.topic }}</span>
          </div>

          <template v-if="messageTemplate.type === 'text'">
            <div class="col-md-6" style="white-space: pre-wrap;"
                 :class="[messageTemplate.attachment && getFileExtension(messageTemplate.attachment) === 'mp4' ? 'col-lg-3' : 'col-lg-5']">
              <span v-if="messageTemplate.message">{{ messageTemplate.message }}</span>
            </div>
            <div class="col-md-2"
                 :class="[messageTemplate.attachment && getFileExtension(messageTemplate.attachment) === 'mp4' ? 'col-lg-3' : 'col-lg-1']">
              <div v-if="messageTemplate.attachment">
                <div style="height: 180px;" v-if="getFileExtension(messageTemplate.attachment) === 'mp4'">
                  <vue-plyr>
                    <video
                      :src="messageTemplate.attachment"
                      format="audio/mp4"
                    />
                  </vue-plyr>
                </div>
                <div class="image-square-cropper-md mx-auto border-secondary" v-else>
                  <a href="" @click.prevent="displayPreviewImage(messageTemplate.attachment)">
                    <img
                      v-lazy="messageTemplate.attachment"
                      class="image-square-child"
                    />
                  </a>
                </div>
              </div>
              <div style="height: 48px;" v-else>&nbsp;</div>
            </div>
          </template>
          <template v-else>
            <div class="col-lg-6 col-md-4">
              <span class="d-inline-block pr-2" v-for="(image, index) in messageTemplate.images" :key="index">
                <a href="" @click.prevent="displayPreviewImage(image.url)">
                  <img :src="image.url" alt="" class="rounded" width="" height="100">
                </a>
              </span>
            </div>
          </template>
          <div class="col-lg-1 col-md-2 text-center">
            <a href="" class="btn btn-link" @click.prevent="setIsEditing(true)">
              <i class="fa fa-pencil-alt"></i> แก้ไข
            </a>
          </div>
        </div>
        <!-- Editing template-->
        <div class="row d-flex align-items-center" v-else>
          <div class="col-lg-1 col-md-2 text-center">
            <h6>/{{ messageTemplate.key }}</h6>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <select name="category" v-model="message_template_category_id" class="form-control">
                <option value="">กรุณาเลือกหมวดหมู่</option>
                <option v-for="(item, index) in categories" :value="item.id" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <input type="text" class="form-control"
                     placeholder="หัวข้อ Shortcut"
                     v-model="topic">
            </div>
          </div>

          <div class="col-lg-5 col-md-4">
            <div class="d-flex justify-content-start align-items-center" v-if="messageTemplate.type === 'text'">
              <div class="flex-grow-1 mr-4">
                <textarea
                  rows="5"
                  class="form-control"
                  id="content"
                  placeholder="พิมพ์ข้อความ..."
                  v-model="message"
                />
              </div>
              <div>
                <div v-if="imgUrl">
                  <div v-if="fileUploadExt === 'mp4'">
                    <div role="button"
                      class="text-right"
                      @click="confirmDeleteAttachment()">
                      <i class="fa fa-times-circle fa-lg"></i>
                    </div>
                    <div style="height: 240px;">
                      <vue-plyr>
                        <video
                          :src="imgUrl"
                          format="audio/mp4"
                        />
                      </vue-plyr>
                    </div>
                  </div>
                  <div role="button" class="uploaded-image-parent" v-else>
                    <div
                      class="uploaded-image-child"
                      @click="confirmDeleteAttachment()">
                      <i class="fa fa-times-circle fa-lg"></i>
                    </div>
                    <div class="image-square-cropper-lg">
                      <img :src="imgUrl" alt="" class="image-square-child"/>
                    </div>
                  </div>
                </div>
                <div
                  role="button"
                  class="upload-box"
                  @click="clickFileUpload()"
                  v-else>
                  <div class="h-100 w-100">
                    <div class="text-center my-4">
                      <i class="fa fa-photo-video fa-2x"></i>
                      <div class="text-small">เพิ่มรูปภาพ/วิดีโอ</div>
                    </div>
                  </div>
                  <input
                    type="file"
                    ref="fileUpload"
                    @change="handleFileUpload"
                    hidden
                  />
                </div>
              </div>
            </div>
            <div v-else-if="messageTemplate.type === 'image'">
              <vue-dropzone ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-mounted="loadPictures"
                            @vdropzone-processing="dzChangeUrl"
                            @vdropzone-success="dzSuccess"
                            @vdropzone-removed-file="dzRemoveFile"></vue-dropzone>
            </div>
            <hr>
            <div>
              <a href="" class="btn btn-outline-info"
                 @click.prevent="setTemplateType('image')"
                 v-if="messageTemplate.type === 'text'">
                <i class="fa fa-images"></i> เปลี่ยนเป็นแกลอรี่
              </a>
              <button class="btn btn-outline-info"
                      @click="setTemplateType('text')"
                      v-if="messageTemplate.type === 'image'">
                <i class="fa fa-comment"></i> เปลี่ยนเป็นข้อความ
              </button>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 text-center">
            <button class="btn btn-link" @click="updateMessageTemplate()" :disabled="isLoading">
              {{ isLoading ? 'กำลังโหลด...' : 'ตกลง' }}
            </button>
            <button class="btn btn-link" @click="cancelUpdate()">ยกเลิก</button>
          </div>
        </div>
      </div>
    </div>
    <preview-image-modal ref="previewImageModal"></preview-image-modal>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import PreviewImageModal from '../modal/PreviewImageModal'

export default {
  props: {
    messageTemplate: Object
  },
  components: {
    vueDropzone: vue2Dropzone,
    PreviewImageModal
  },
  data () {
    return {
      apiUrl: 'https://api.beneat-chat.com',
      message: null,
      fileUpload: null,
      fileUploadExt: null,
      imgUrl: null,
      isEditing: false,
      isDzDestroying: false,
      dropzoneOptions: {
        url: null,
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        destroyDropzone: false,
        addRemoveLinks: true,
        autoProcessQueue: true,
        dictDefaultMessage: '<i class=\'fa fa-upload\'></i> อัพโหลดไฟล์'
      },
      previewImageUrl: null,
      message_template_category_id: null,
      topic: '',
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      categories: state => state.messageTemplate.categories
    })
  },
  beforeDestroy () {
    this.isDzDestroying = true
  },
  destroyed () {
    this.isDzDestroying = false
  },
  watch: {
    isEditing () {
      if (this.isEditing) {
        this.message = this.messageTemplate.message
        this.imgUrl = this.messageTemplate.attachment
        this.fileUploadExt = this.getFileExtension(this.messageTemplate.attachment)
        this.message_template_category_id = this.messageTemplate.category ? JSON.parse(JSON.stringify(this.messageTemplate.category.id)) : ''
        this.topic = JSON.parse(JSON.stringify(this.messageTemplate.topic))
      }
    }
  },
  methods: {
    ...mapActions('messageTemplate', ['fetchMessageTemplates', 'deleteImage']),
    displayPreviewImage (url) {
      this.$refs.previewImageModal.open(url)
    },
    dzChangeUrl (file, xhr, formData) {
      this.$refs.myVueDropzone.setOption('url', `${this.apiUrl}/message-templates/${this.messageTemplate.id}/images?uuid=${file.upload.uuid}`)
    },
    dzSuccess (file, response) {
      console.log('dz success', file, response)
    },
    dzRemoveFile (file, error, xhr) {
      if (this.isDzDestroying) {
        return
      }
      const submitData = {
        id: this.messageTemplate.id,
        uuid: (file.upload) ? file.upload.uuid : file.uuid
      }
      this.deleteImage(submitData)
    },
    setIsEditing (status) {
      this.isEditing = status
    },
    setTemplateType (type) {
      this.messageTemplate.type = type
    },
    clickFileUpload () {
      this.$refs.fileUpload.click()
    },
    handleFileUpload () {
      this.fileUpload = this.$refs.fileUpload.files[0]
      this.fileUploadExt = this.getFileExtension(this.fileUpload.name)
      this.imgUrl = URL.createObjectURL(this.fileUpload)
    },
    getFileExtension (url) {
      return url ? url.split(/[#?]/)[0].split('.').pop().trim() : null
    },
    cancelUpdate () {
      this.setIsEditing(false)
      this.message = null
      this.fileUpload = null
      this.imgUrl = null
    },
    confirmDeleteAttachment () {
      const text = (this.fileUploadExt === 'mp4') ? 'คุณต้องการลบวิดีโอใช่หรือไม่' : 'คุณต้องการลบรูปนี้ใช่หรือไม่'
      this.$swal({
        text,
        showCancelButton: true,
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async result => {
        if (result.isConfirmed) {
          await this.deleteAttachment()
        }
      })
    },
    async deleteAttachment () {
      const url = `/message-templates/${this.messageTemplate.id}/attachment`
      const res = await axios.delete(url)
      if (res.status === 200) {
        this.imgUrl = null
        const updatedMessageTemplate = res.data
        this.$store.commit(
          'messageTemplate/UPDATE_MESSAGE_TEMPLATE',
          updatedMessageTemplate
        )
      }
    },
    async updateMessageTemplate () {
      this.isLoading = true
      let formData = new FormData()
      formData.append('type', this.messageTemplate.type)
      if (this.message) {
        formData.append('message', this.message)
      }
      if (this.message_template_category_id) {
        formData.append('message_template_category_id', this.message_template_category_id)
      }
      if (this.topic) {
        formData.append('topic', this.topic)
      }
      if (this.fileUpload) formData.append('fileUpload', this.fileUpload)
      // Update message template
      const url = (this.fileUploadExt === 'mp4') ? `/message-templates/${this.messageTemplate.id}/video` : `/message-templates/${this.messageTemplate.id}`
      const res = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (res.status === 200) {
        const updatedMessageTemplate = res.data
        this.$store.commit(
          'messageTemplate/UPDATE_MESSAGE_TEMPLATE',
          updatedMessageTemplate
        )

        // ให้ Fetch Data ใหม่ของ MessageBox
        this.$store.commit('messageTemplate/SET_MESSAGE_TEMPLATES', {
          messageTemplates: [],
          customerType: this.messageTemplate.customer_type
        })
        const paramsFetchMessage = {
          page: 0,
          customer_type: this.messageTemplate.customer_type,
          limit: 50,
          show_categories: 1,
          keyword: ''
        }
        this.fetchMessageTemplates(paramsFetchMessage)
        this.cancelUpdate()
      }
      this.isLoading = false
    },
    loadPictures () {
      if (this.messageTemplate.images) {
        this.messageTemplate.images.forEach(image => {
          const file = {
            size: 123,
            uuid: image.uuid,
            name: image.original_name,
            type: image.type,
            dataURL: image.url
          }
          this.$refs.myVueDropzone.manuallyAddFile(file, image.url)
          this.$refs.myVueDropzone.dropzone.emit('thumbnail', file, file.dataURL)
          this.$refs.myVueDropzone.dropzone.emit('complete', file)
        })
      }
    }
  },
  mounted () {
    if (window.location.hostname === 'localhost') {
      this.apiUrl = 'http://localhost:3000'
    }
    this.dropzoneOptions.url = `${this.apiUrl}/message-templates/${this.messageTemplate.id}/images`
  }
}
</script>
